import clone from "clone";
import React from "react";
import styled from "styled-components";
import { Select, SelectOption } from "../../../designSystem/inputs/Select";
import { Checkbox, CheckboxList, CheckboxOption } from "../../../designSystem/inputs/Checkbox";
import { RadioButtonOption, RadioButtonList } from "../../../designSystem/inputs/RadioButton";
import { OnOff } from "../../../designSystem/inputs/OnOff";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H2, H3 } from "../../../designSystem/typography/Heading";
import { RadioButtonButton, RadioButtonButtonList } from "../../../designSystem/inputs/RadioButtonButton";
import { Icon } from "../../../designSystem/icons/Icons";
import { ImportanceAvatar } from "../../../designSystem/avatar/ImportanceAvatar";
import { ButtonRadioButton } from "../../../designSystem/inputs/ButtonRadioButton";

export const SelectionOverview = (): JSX.Element => 
{
    return (
        <>
            <RadioButtonOverview />

            <OnOffOverview />

            <SelectOverview />

            <CheckboxOverview />
        </>
    );
}

export const RadioButtonOverview = (): JSX.Element => 
{
    const [selectedValue, setSelectedValue] = React.useState('');
    
    function handleRadioButtonChange(value:string)
    {
        //alert('value changing: ' + value + " set to " + value);
        setSelectedValue(value);
    }

    const radioButtonOptions:RadioButtonOption[] =
        [
            { text:'Asparges', value:'asparges'},
            { text:'Løg', value:'løg'},
            { text:'Selleri', value:'selleri'},
        ];

    const o1 = radioButtonOptions[0];
    const o2 = radioButtonOptions[1];
    const o3 = radioButtonOptions[2];

    return (
        <>
            <h2>RadioButtonButton</h2>
            <Container>
                <Flex>
                    <RadioButtonButton id={o1.value} border='both' roundedCorner="left" name="buttonButtons1" text={o1.text} value={o1.value} checked={o1.value === selectedValue} onChange={handleRadioButtonChange} />
                    <RadioButtonButton id={o2.value} border='right' name="buttonButtons1" text={o2.text} value={o2.value} checked={o2.value === selectedValue} onChange={handleRadioButtonChange}  />
                    <RadioButtonButton id={o3.value} border="right" roundedCorner="right" name="buttonButtons1" text={o3.text} value={o3.value} checked={o3.value === selectedValue} onChange={handleRadioButtonChange}  />
                </Flex>
            </Container>
            <h2>RadioButtonButton with icons</h2>
            <Container>
                <Flex>
                    <RadioButtonButton id={o1.value} leadingContent={<Icon name="actions_close" color="red" />} border='both' roundedCorner="left" name="buttonButtons1" text={o1.text} value={o1.value} checked={o1.value === selectedValue} onChange={handleRadioButtonChange} />
                    <RadioButtonButton id={o2.value} leadingContent={<ImportanceAvatar importance="high" />} border='right' name="buttonButtons1" text={o2.text} value={o2.value} checked={o2.value === selectedValue} onChange={handleRadioButtonChange}  />
                    <RadioButtonButton id={o3.value} leadingContent={<Icon name="add_circle_fill" color="blue" />} border="right" roundedCorner="right" name="buttonButtons1" text={o3.text} value={o3.value} checked={o3.value === selectedValue} onChange={handleRadioButtonChange}  />
                </Flex>
            </Container>
            <h2>RadioButtonButton disabled</h2>
            <Container>
                <Flex>
                    <RadioButtonButton id={o1.value} border='both' name="buttonButtons2" text={o1.text} value={o1.value} checked={o1.value === selectedValue} onChange={handleRadioButtonChange} disabled />
                    <RadioButtonButton id={o2.value} border='right' name="buttonButtons2" text={o2.text} value={o2.value} checked={o2.value === selectedValue} onChange={handleRadioButtonChange} disabled />
                    <RadioButtonButton id={o3.value} border='right' name="buttonButtons2" text={o3.text} value={o3.value} checked={o3.value === selectedValue} onChange={handleRadioButtonChange} disabled />
                </Flex>
            </Container>
            <h2>RadioButtonButtonList</h2>
            <Container>
                <Flex>
                    <RadioButtonButtonList groupName="buttonButtons3" 
                        options={[
                            { text:'Asparges', value:'asparges', selectedColorProfile:{
                                backgroundSelected:'green',
                                text:'white',
                                textHover:'white'
                            }},
                            { text:'Løg', value:'løg', selectedColorProfile:{
                                backgroundSelected:'red',
                                text:'white',
                                textHover:'white'
                            }},
                            { text:'Selleri', value:'selleri', selectedColorProfile:{
                                backgroundSelected:'blue',
                                text:'white',
                                textHover:'white'
                            }},
                        ]} 
                        selectedValue={selectedValue} onChange={handleRadioButtonChange}  />
                </Flex>
            </Container>

            <h2>ButtonRadioButton</h2>
            <Container style={{width:300}}>
                <Flex flexDirection="column" gap={8}>
                    <ButtonRadioButton
                        hideBorder
                        id={o1.value}
                        text={o1.text}
                        value={o1.value}
                        checked={o1.value === selectedValue}
                        onChange={handleRadioButtonChange}
                        leadingContent={{ icon: 'actions_done', color: 'black' }} 
                        trailingContent={{ icon:'construction', color:'gray'}}
                        name={""}
                    />
                    <ButtonRadioButton
                        id={o2.value}
                        text={o2.text}
                        value={o2.value}
                        checked={o2.value === selectedValue}
                        onChange={handleRadioButtonChange}
                        leadingContent={{ icon: 'actions_close', color: 'red' }} 
                        name={""}
                    />
                    <ButtonRadioButton
                        id={o3.value}
                        text={o3.text}
                        value={o3.value}
                        checked={o3.value === selectedValue}
                        onChange={handleRadioButtonChange}
                        leadingContent={{ icon: 'actions_close', color: 'red' }}
                        disabled
                        name={""}
                    />
                </Flex>
            </Container>

            <h2>RadioButtonList</h2>
            <Container>
                <h3>Vertical (default))</h3>
                <Row>
                    <div>
                        <RadioButtonList 
                            groupName={"veggies1"}
                            selectedValue={selectedValue}
                            options={radioButtonOptions}
                            onChange={handleRadioButtonChange} />
                    </div>
                </Row>
                <h3>Vertical (explicit))</h3>
                <Row>
                    <div>
                        <RadioButtonList 
                            flexDirection="column"
                            groupName={"veggies2"}
                            selectedValue={selectedValue}
                            options={radioButtonOptions}
                            onChange={handleRadioButtonChange}
                            justifyContent="space-between" />
                    </div>
                </Row>
                <h3>Horizontal</h3>
                <Row>
                    <div>
                        <RadioButtonList 
                            flexDirection="row"
                            groupName={"veggies3"}
                            selectedValue={selectedValue}
                            options={radioButtonOptions}
                            onChange={handleRadioButtonChange} />
                    </div>
                </Row>
                <h3>Horizontal Disabled</h3>
                <Row>
                    <div>
                        <RadioButtonList 
                            disabled={true}
                            flexDirection="row"
                            groupName={"veggies4"}
                            selectedValue={selectedValue}
                            options={radioButtonOptions}
                            onChange={handleRadioButtonChange}
                            justifyContent="space-between" />
                    </div>
                </Row>
                
            </Container>
        </>
    );
}

const OnOffOverview = (): JSX.Element => {

    const [active, setActive] = React.useState(false);

    function OnOffButtonToggle()
    {
        setActive(!active);
        
    }

    return (
        <Flex flexDirection="column" gap={4}>
            <H2>Come on, turn me on!</H2>
            <Flex flexDirection="column" gap={16}>
                <Flex flexDirection="column" gap={4}>
                    <H3>small</H3>
                    <Flex flexDirection="column" gap={4}>  
                        <Flex flexDirection="row" gap={8}>
                            <OnOff active={active} onClick={OnOffButtonToggle} size="small" />
                            <OnOff active={active} onClick={OnOffButtonToggle} size="small" disabled/>
                        </Flex>        
                        
                        <Flex flexDirection="row" gap={8}>

                            <OnOff active={active} variant={"fullColor"} onClick={OnOffButtonToggle} size="small" />
                            <OnOff active={active} variant={"fullColor"} onClick={OnOffButtonToggle} size="small" disabled />
                        </Flex>


                    </Flex>
                    
                    <H3>medium</H3>
                    <Flex flexDirection="row" gap={8}>
                        <OnOff active={active} onClick={OnOffButtonToggle} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} />
                        <OnOff active={active} onClick={OnOffButtonToggle}/>
                        <OnOff active={active} onClick={OnOffButtonToggle} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} disabled />
                    </Flex>    
                    <Flex flexDirection="row" gap={8}>
                        <OnOff active={active} onClick={OnOffButtonToggle} variant={"fullColor"} text={{width:100, active:'ON', inactive:'OFF'}} />
                        <OnOff active={active} onClick={OnOffButtonToggle} variant={"fullColor"} />
                        <OnOff active={active} onClick={OnOffButtonToggle} variant={"fullColor"} text={{width:100, active:'ON', inactive:'OFF'}} disabled />
                        {/* <OnOff active={active} variant={"fullColor"} text={{active:'Tilføjet', inactive:'Tilføj'}} onClick={OnOffButtonToggle} width={90} size="small" /> */}
                    </Flex>

                    <H3>large</H3>
                    <Flex flexDirection="row" gap={8}>
                        <OnOff active={active} onClick={OnOffButtonToggle} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} size="large" />
                        <OnOff active={active} onClick={OnOffButtonToggle} size="large" />
                        <OnOff active={active} onClick={OnOffButtonToggle} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} size="large" disabled />
                    </Flex>      
                    
                    <Flex flexDirection="row" gap={8}>
                        <OnOff active={active} onClick={OnOffButtonToggle} variant={"fullColor"} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} size="large" />
                        <OnOff active={active} onClick={OnOffButtonToggle} variant={"fullColor"} size="large" />
                        <OnOff active={active} variant={"fullColor"} text={{width:120, active:'Tilføjet', inactive:'Tilføj'}} size="large" disabled />
                    </Flex>  

                            
                    
                </Flex>
                
                
            </Flex>

        </Flex>
    )
}


export const SelectOverview = (): JSX.Element => 
{
    const [selectedValue, setSelectedValue] = React.useState('');
    
    function handleRadioButtonChange(value:string)
    {
        //alert('value changing: ' + value + " set to " + value);
        setSelectedValue(value);
    }

    const selectOptions:SelectOption[] =
        [
            { text:'Cola', value:'cola'},
            { text:'Rødvin', value:'rødvin'},
            { text:'Whiskey', value:'whiskey'},
            { text:'Øl', value:'øl'}
        ];

    return (
        <>
            <h2>Select</h2>
            <Container>
                <Row>
                    <div>
                        <h3>Simple select</h3>
                        <Select 
                            selectedValue={selectedValue}
                            options={selectOptions}
                            onChange={handleRadioButtonChange} />
                    </div>
                    <div>
                        <h3>Disabled</h3>
                        <Select 
                            selectedValue={selectedValue}
                            options={selectOptions}
                            onChange={handleRadioButtonChange}
                            disabled={true} />
                    </div>
                </Row>
            </Container>
        </>
    );
}

function CheckboxOverview(): JSX.Element
{
    const [checkboxOptions, setCheckboxOptions] = React.useState<CheckboxOption[]>(
        [
            { text:'Banan', value:'banan', checked:true},
            { text:'Citron', value:'citron', checked:true},
            { text:'Lime (fancy citron)', value:'lime', checked:false},
            { text:'Mango', value:'mango', checked:true},
        ]);

    function handleCheckboxChange(value:string, checked:boolean)
    {
        //alert('value changing: ' + value + " set to " + checked);
        
        const list = clone(checkboxOptions);
        const item = list.find(i => i.value === value);
        item.checked = checked;
        setCheckboxOptions(list);
    }

    function handleCheckboxListChange(item:CheckboxOption, allItems:CheckboxOption[])
    {
        //alert('List changing - concrete value: ' + item.value + " set to " + item.checked);

        setCheckboxOptions(allItems);
    }

    const bananOption = checkboxOptions.find(i => i.value === 'banan');
    const citronOption = checkboxOptions.find(i => i.value === 'citron');
    const mangoOption = checkboxOptions.find(i => i.value === 'mango');

    return (
        <>
            <h2>Single Checkbox</h2>
            <Container>
                <Row>
                    <div>
                        <Checkbox value={bananOption.value} text={bananOption.text} checked={bananOption.checked} onChange={handleCheckboxChange} />
                        <Checkbox value={citronOption.value} text={citronOption.text} checked={citronOption.checked} onChange={handleCheckboxChange} />
                        <Checkbox value={mangoOption.value} text={mangoOption.text + ' disabled'} checked={mangoOption.checked} onChange={handleCheckboxChange} disabled={true} />
                    </div>
                </Row>
            </Container>

            <h2>CheckboxList</h2>
            <Container>
                <h3>Vertical (default))</h3>
                <Row>
                    <div>
                        <CheckboxList 
                            options={checkboxOptions}
                            onChange={handleCheckboxListChange} />
                    </div>
                </Row>
                <h3>Horizontal</h3>
                <Row>
                    <div>
                        <CheckboxList 
                            flexDirection="horizontal"
                            options={checkboxOptions}
                            onChange={handleCheckboxListChange} />
                    </div>
                </Row>
                <h3>Horizontal Disabled</h3>
                <Row>
                    <div>
                        <CheckboxList 
                            flexDirection="horizontal"
                            options={checkboxOptions}
                            onChange={handleCheckboxListChange}
                            disabled={true} />
                    </div>
                </Row>
            </Container>
        </>
    );
}

const Container = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #888;
`;

const Row = styled.div`
    gap:20px;
    display: flex;
    flex-direction: row;
    align-items: stretch;

    & > * {
        flex-grow: 1;
    }
`;